import { FelaCSS } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSS;
  networksWrap: FelaCSS;
  network: FelaCSS;
}

const styles = (): IStyles => ({
  wrapper: {
    alignItems: 'center',
    marginBottom: 6,

    maxWidthTabletSm: {
      marginBottom: 2,
    },
  },

  networksWrap: {
    flexDirection: 'row',
  },

  network: {
    ':not(:last-of-type)': {
      marginRight: '32px',
    },
  },
});

export default styles;
